module.exports = __webpack_public_path__ + "img/formtopright.804ee89f.svg";